module.exports = __webpack_public_path__ + "img/细胞治疗研究员.23345efa.jpg";